<template>
  <hm-content title>
    <div class="flex flex-between item-center mb20">
      <div class="flex">
        <el-button type="primary"size="small"@click="AddServiceProject">新增服务预约</el-button>
      </div>
      <div class="table-panel flex flex-end">
        <el-select v-model="searchCondition.projectTypeId" placeholder="请选择服务类型" class="mr10" size="small" filterable clearable>
          <el-option v-for="(item,index) in serviceTypeList" :label="item.serviceType" :value="item.id"  :key="index"></el-option>
        </el-select>

        <el-input class="mr10" size="small" placeholder="请输入服务名称" v-model="searchCondition.serviceName" clearable></el-input>
        <el-button  class="mr10" size="small" type="primary" @click="queryList">查询</el-button>
        <el-button class="mr10" size="small" type="primary" @click="output" :loading="isOutputing">导出</el-button>

      </div>  
    </div>
    <div>
      <el-table stripe border :data="serviceProject" style="width: 100%" id="table" size="small">
      <el-table-column header-align="center" align="center" type="index" label="序号" :index="(index) => index + (currentPage - 1) * pageSize + 1"></el-table-column>
      <el-table-column header-align="center" align="center" prop="projectTypeName" label="项目分类"></el-table-column>
      <el-table-column header-align="center" align="center" prop="serviceName" label="服务名称"></el-table-column>
      <el-table-column header-align="center" align="center" prop="createTime" label="创建时间"></el-table-column>
        <el-table-column header-align="center" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled === 'open'" class="success"
              >开启</span
            >
            <span v-if="scope.row.isEnabled === 'close'" class="gray"
              >关闭</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="sortNum"
          label="排序"
        ></el-table-column> -->
        <el-table-column header-align="center" align="center" prop="reservationNumber" label="已预约人数"></el-table-column>
        <el-table-column header-align="center" align="center" prop="performNumber" label="已核销人数"></el-table-column>
        <el-table-column header-align="center" align="center" prop="categoryName" label="操作" width="400px">
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
               <!-- <el-button
                type="text"
                class="blue"
                size="small"
                @click="productQrcode(scope.row)"
                >二维码</el-button
              > -->
              <el-button type="text" class="blue" size="small" @click="edit(scope.row)">编辑</el-button>
              <el-button type="text" class="blue" size="small" @click="makeAnAppointmentAtTheStore(scope.row)">可预约服务商店</el-button>
              <el-button type="text" class="blue" size="small" @click="makeAnAppointmentWithATechnician(scope.row)">可预约服务技师</el-button>
              <el-button type="text" class="blue" size="small" @click="editTimeRules(scope.row)">可预约时段</el-button>
              <el-button type="text" class="red" size="small" @click="toDetails(scope.row)">删除</el-button>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChanges"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>




    <!-- 新增门店 -->
    <el-dialog
      title="查看商店"
      :visible.sync="viewDialogVisibleAddAStore"
      width="1230px"
      >
      <el-button type="primary" size="small" @click="authorizedStoresHaveBeenAdded" style="margin-bottom: 20px;">新增授权商店</el-button>


      <checkOutTheAuthorizedStores @getTheSelectedStore="getTheSelectedStore" :checkOutTheStoreData="checkOutTheStoreData"></checkOutTheAuthorizedStores>
   
    </el-dialog>



    <el-dialog
      title="添加商店"
      :visible.sync="dialogVisibleAddAStore"
      width="1230px"
      >
    
      <storesTableAuthorization ref="storesTableAuthorizationRef" @getTheSelectedStore="getTheSelectedStore" :checkOutTheStoreData="checkOutTheStoreData"></storesTableAuthorization>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisibleAddAStore = false">取 消</el-button>
        <el-button size="small" type="primary" @click="storesTableAreYouSure">确 定</el-button>
      </span>
    </el-dialog>






   

    <!-- 查看可预约服务技师 -->
    <!-- <techniciansCanBeBooked
      selectType="multiple"
      v-if="dialogVisibleEmp"
      :seeAvailableServiceTechnicians="true"
      :viewAvailableTechnicianData = "viewAvailableTechnicianData"
      @handleClickScopeOfAppointments="handleClickScopeOfAppointments"
      @setMultipleEmpInfo="setMultipleEmpInfo"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
      :isRole="true"
    ></techniciansCanBeBooked> -->
    <techniciansCanBeBooked
      selectType="multiple"
      v-if="dialogVisibleEmp"
      :seeAvailableServiceTechnicians="true"
      :viewAvailableTechnicianData = "viewAvailableTechnicianData"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
      :isRole="true"
    ></techniciansCanBeBooked>

 

    <!-- 查看可预约时间段 -->
     <el-dialog
      title="查看规则"
      :visible.sync="editEdARulePopUpWindow"
      width="1000px"
      >
      
      <div>
        <div style="display: flex;align-items: center; margin-bottom: 20px;">
          <p style="margin-right: 20px;">时间规则</p>
          <el-select size="small" v-model="ruleNameId" placeholder="请选择" @change="ruleNameChange">
            <el-option
              v-for="item in timeRulesList"
              :key="item.id"
              :label="item.ruleName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>



        <div class="li" style="padding: 20px; border: 1px solid #e4e4e4; border-radius: 5px;">
          <h3>{{ editTheData.ruleName }}<el-button type="primary" size="mini"</h3>
          <el-form
          :model="editTheData"
          label-width="130px"
          >

          <el-form-item label="启用状态">
            <el-radio-group v-model="editTheData.isEnabled" disabled>
              <el-radio label="open">开启</el-radio>              
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="可预约服务范围:">
            可预约当天
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              disabled
              v-model.number="editTheData.futureStartDayNum"
              placeholder="开始天数"
              maxlength="3"
            ></el-input>
            天后到
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              disabled
              v-model.number="editTheData.futureEndDayNum"
              placeholder="结束天数"
              maxlength="3"
            ></el-input>
            天后的日期范围<span class="danger">(填0则表示预约当天)</span>
          </el-form-item>

          <el-form-item label="服务时间段:">
            <el-time-select
              placeholder="起始时间"
              v-model="editTheData.startTimeQuantum"
              disabled
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
              }"
            >
            </el-time-select>
            <span class="ml10 mr10">至</span>
            <el-time-select
              placeholder="结束时间"
              class="mr10"
              v-model="editTheData.endTimeQuantum"
              disabled
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
                minTime: editTheData.startTimeQuantum,
              }"
            >
            </el-time-select>
        
            <div v-if="editTheData.timeQuantumList && editTheData.timeQuantumList.length > 0">
              <div>已选时段</div>
              <div class="timeList" style="opacity: 0.5;">
                <div
                  class="timeListItem mb10"
                  v-for="(item, index) in editTheData.timeQuantumList"
                  :key="index"
                >
                  <div>
                    <span class="text mr10">
                      {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                    >
                    
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          </el-form>
        </div>

      </div>

      <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px;">
        <el-button type="primary" size="small" @click="editOk">确定</el-button>
        <el-button size="small" @click="editEdARulePopUpWindow = false">取消</el-button>
      </div>
    </el-dialog>
    
      




  </hm-content>
</template>

<script>
import techniciansCanBeBooked from "./components/techniciansCanBeBooked";
import checkOutTheAuthorizedStores from "./components/checkOutTheAuthorizedStores";
import storesTable from "./components/storesTable";
import storesTableAuthorization from "./components/storesTableAuthorization";
export default {
  components: {techniciansCanBeBooked, storesTable, checkOutTheAuthorizedStores , storesTableAuthorization},
  data() {
    return {
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      ruleNameId: '',
      selectedStore:[],
      dateRuleId:'',
      timeRulesList:[],
      editTheData: {},
      editTimeRulesRow:{},
      viewAvailableTechnicianData: {},
      checkOutTheStoreData:{},
      viewDialogVisibleAddAStore: false,
      editEdARulePopUpWindow: false,
      electedStore:[],
      dialogVisibleAddAStore: false,
      dialogVisibleEmp: false,
      rightData: [],
      currentPage: 1,
      pageSize: 10,
      serviceProject:[],   
      total:0,   
      searchCondition:{},
      serviceTypeList:[],
      isOutputing: false,
      ruleForm: {
        serviceTypeId: "",
        serviceProjectName: "",
        subscribeStartDate: "",
        subscribeEndDate: "",
        enableStartDay: "",
        enableEndDay: "",
        mainImgUrl: "",
        shopRelModelList: [
          {
            shopId: "",
            enabledState: "yes",
            empRelModelList: [],
            isShowDateList: false,
            dateList: [],
          },
        ],
        timeQuantumRelModelList: [],
        formStatus: "open",
        enabledState: "yes",
        subscribe: [],
        schedulingMode: "add",
        qaMode: "close",
        qaContent:"{}",
      },
      rules: {        
        serviceTypeId: [
          { required: true, message: "请选择服务类型", trigger: "change" },
        ],
        serviceProjectName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" },
        ],
        subscribe: [
          { required: true, message: "请选择预约日期", trigger: "change" },
        ],
        singleTechnicianLimitNum:[{
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
            }
        ],
        singleMemberLimitNum:[{
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
            }
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryServiceRestorationTypeList();
    this.queryList();
    // this.timeRulesListFun();
  },
  methods: {
    async ruleNameChange(){
      const {result} = await this.$store.dispatch("queryServiceDateRuleList",{
        id: this.ruleNameId,
      })
      if(result){
        this.editTheData = result[0];
      }
    },
      // 时段 
    async editTimeRules(row){
      this.editTimeRulesRow = row;
      this.ruleNameId = '';
      if(row.dateRuleId){
        this.ruleNameId = row.dateRuleId;
        this.ruleNameChange();
      }
      const { result } = await this.$store.dispatch("queryServiceDateRuleList");
      this.timeRulesList = result;
      this.editEdARulePopUpWindow = true;
    },
    // 编辑提交
    async editOk(){
      if(!this.ruleNameId){
        this.$message.error("请选择时间规则");
        return;
      }
   
      const { code } = await this.$store.dispatch("saveServiceProjectInfoDateRuleRel",{
       id: this.editTimeRulesRow.id,
       dateRuleId: this.ruleNameId,
      });
      if(code == 0){
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.editTheData = {};
        this.editTimeRulesRow = {};
        this.editEdARulePopUpWindow = false;
        this.queryList();
      }
    },
  
    // 新增授权商店
    authorizedStoresHaveBeenAdded(){
      this.dialogVisibleAddAStore = true;
      this.$nextTick(() => {
        this.$refs.storesTableAuthorizationRef.queryList('reset');
      });
      this.viewDialogVisibleAddAStore = false;
    },
    // 门店
    makeAnAppointmentAtTheStore(row){
      this.checkOutTheStoreData = row;
      this.viewDialogVisibleAddAStore = true;
      // this.$refs.checkOutTheAuthorizedStoresRef.queryList('reset');
    },
    // 技师
    makeAnAppointmentWithATechnician(row){
      this.viewAvailableTechnicianData = row;
      this.dialogVisibleEmp = true;
    },
    
     // 获取选中门店
     getTheSelectedStore(val){
      this.selectedStore = val;
      // console.log("selectedStore:", this.selectedStore);
    },
     // 添加门店 确定 
     async storesTableAreYouSure(){
      let serviceProjectInfoShopIdList = this.selectedStore.map(e => e.id);
      // console.log("获取门店数据", serviceProjectInfoShopIdList);
      const { code } = await this.$store.dispatch("saveServiceProjectInfoShopRel", {
        id: this.checkOutTheStoreData.id,
        serviceProjectInfoShopIdList
      });

       if(code == 0){
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogVisibleAddAStore = false;
          this.queryList();
       }
       this.selectedStore = [];
    },
    AddServiceProject() {
      this.$router.push({ name: "AddServiceProject" });
    },
    // 删除
     toDetails(row){
      // console.log("row:", row);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code } = await this.$store.dispatch("delServiceProjectInfo", {
            id: row.id
          });
          if(code == 0){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryList();
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    edit(row) {
      this.$router.push({
        name: "EditServiceProject",
        query: {
          id: row.id
        }
      });
    },
    async queryServiceRestorationTypeList() {
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationTypeList",
        {}
      );
      // console.log("result:", result);
      if (result) {
        this.serviceTypeList = result;
      }
    }, 
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      // console.log("99999:", this.searchCondition);
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "storeServiceProjectInfoQueryPageList",
          params
        );
        const { records, total } = result;
        this.serviceProject = records;
        this.total = total;

    },
    switchTab() {
      this.rightData = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.rightCheckAll = false;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // async productQrcode(id) {
    //   let params = `id=${id}`;

    //   const url = await this.$store.dispatch("shareDataSave", {
    //     url: params
    //   });

    //   const { result } = await this.$store.dispatch("createCouponQrcode", {
    //     path: `serviceReservation/serviceReservationDetail?saveUUID=${url.result}`
    //   });
    //   this.qrcodeDialogVisible = true;
    //   this.activityCode = result;
    // },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList()
          .then((v) => {
            const list = this.serviceProject;
            list.forEach(v => {
              if(v.enabledState==='yes'){
                v.enabledState = '开启'
              }else if(v.enabledState==='no'){
                v.enabledState = '关闭'
              }
            });
            const tHeader = [
              "服务类型",
              "服务名称",
              "创建时间",
              "状态",              
              "已预约人数",
              "已核销人数",
            ];
            const filterVal = [
              "serviceType",
              "serviceProjectName",
              "createTime",
              "enabledState",              
              "applyNum",
              "chargeNum",
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "服务预约列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },


  },
};
</script>
<style>
.el-date-range-picker .el-picker-panel__body {
    max-width: 600px;
  }
</style>
<style lang="scss" scoped>

.basic-rules {
  border: 1px solid #e4e4e4;
  padding: 20px;
}
h3 {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  background: #e4e4e4;
  display: block;
  margin: 0 0 20px 0;
}
.timeListItem {
  .text {
    width: 356px;
    height: 20px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 12px;
    line-height: 20px;
    display: inline-block;
  }
}
</style>
